module.exports = __webpack_public_path__ + "img/border1.233199a6.png";